// extracted by mini-css-extract-plugin
export default {"container":"List_container__dopO-","searchResult":"List_searchResult__SAwwd","confirmButton":"List_confirmButton__VzUE8","hidden":"List_hidden__KzVOZ"};